import React, { useState, useEffect, useCallback } from 'react';
import { Check, Close } from '@material-ui/icons';
import moment from 'moment-with-locales-es6';
import MicRecorder from 'mic-recorder-to-mp3';
import {
  Container,
  StopButton,
  RecordingBullet,
  SendButton,
  Timer,
  ButtonWrapper
} from './styles';
import { MessageType } from '../../chat-api';
import { useMessageState } from '../../data';

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

function generateUniqueName() {
  return `${Math.random().toString(20).substr(2)}${Date.now().toString()}`;
}

function getTimer(timer: number) {
  const today = moment().utcOffset(0);

  today.set({ hour: 0, minute: 0, second: timer, millisecond: 0 });

  if (timer < 600) {
    return today.format('m:ss');
  } else if (timer < 3600) {
    return today.format('mm:ss');
  } else {
    return today.format('hh:mm');
  }
}

function Audio() {
  const [timer, setTimer] = useState(0);
  const [recordingStarted, setRecordingStarted] = useState(false);
  const { setIsRecordingAudio, isRecordingAudio, uploadAndSend } = useMessageState();

  useEffect(() => {
    if (isRecordingAudio) {
      Mp3Recorder
        .start()
        .then(() => {
          setRecordingStarted(true);
        }).catch(
          (e: any) => console.error(e)
        );
    }
  }, [isRecordingAudio, setIsRecordingAudio]);

  useEffect(() => {
    return () => {
      Mp3Recorder.stop();
    }
  }, []);

  useEffect(() => {
    function stopTimer() {
      clearTimeout(startTimer);
    }
    const startTimer = setTimeout(() => recordingStarted && setTimer(timer + 1), 1000);
    return () => {
      stopTimer();
    }
  }, [timer, recordingStarted])

  const stopRecording = () => {
    Mp3Recorder.stop();
    setIsRecordingAudio(false);
  };

  const sendAudio = useCallback(() => {
    Mp3Recorder
      .stop()
      .getMp3()
      .then((res: any) => {
        const blob = res[1];
        const file = new File([blob], generateUniqueName(), { lastModified: Date.now() });
        uploadAndSend(file, MessageType.Audio);
        setIsRecordingAudio(false);
      }).catch((err: any) => console.error(err));
  }, [setIsRecordingAudio, uploadAndSend]);

  if (!isRecordingAudio) {
    return null;
  }

  return (
    <Container as="sdiv">
      <ButtonWrapper as="sdiv" flex='start'>
        <StopButton onClick={stopRecording}>
          <Close />
        </StopButton>
      </ButtonWrapper>
      <sdiv style={{ justifySelf: 'center' }}>
        <RecordingBullet as="sdiv" />
        <Timer as="sdiv">{getTimer(timer)}</Timer>
      </sdiv>
      <ButtonWrapper as="sdiv" flex='end'>
        <SendButton onClick={sendAudio}>
          <Check />
        </SendButton>
      </ButtonWrapper>
    </Container>
  );
}

export default React.memo(Audio);
